import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function SubSpecialtySelector({ profession, activeSub, basePath }) {
  const navigate = useNavigate();
  const subs = profession.subSpecialties || [];

  const handleClick = (sub) => {
    if (activeSub === sub.slug) {
      navigate(basePath);
    } else {
      navigate(`${basePath}/${sub.slug}`);
    }
  };

  if (!subs.length) return null;

  return (
    <div className="sticky top-[60px] z-40" style={{ backgroundColor: '#EDE8DF', borderBottom: '1px solid #E0DCD3' }} data-testid="sub-specialty-selector">
      <div className="flex flex-wrap items-center justify-center gap-x-1 gap-y-0 px-6 md:px-10 py-3 max-w-5xl mx-auto">
        {subs.map(sub => {
          const isActive = activeSub === sub.slug;
          return (
            <motion.button
              key={sub.slug}
              onClick={() => handleClick(sub)}
              className="relative px-3 py-[6px] transition-colors"
              style={{
                fontSize: '11px',
                fontFamily: "'DM Sans', sans-serif",
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                color: isActive ? '#3C3226' : 'rgba(60,50,38,0.55)',
                fontWeight: isActive ? 600 : 400,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
              whileHover={{ color: '#3C3226' }}
              data-testid={`sub-specialty-${sub.slug}`}
            >
              {sub.name}
              {isActive && (
                <motion.div
                  layoutId="sub-underline"
                  className="absolute bottom-0 left-3 right-3 h-[2px]"
                  style={{ backgroundColor: '#B8985A' }}
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
